import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { IonButton } from '@ionic/react'
import Textarea from 'components/formik/Textarea'

const validationSchema = Yup.object({
  reason_for_declining: Yup.string().required(
    'Please provide a reason for declining.'
  ),
})

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
const defaultProps = {}

function DeclineForm({ onSubmit, onCancel }) {
  return (
    <Formik
      initialValues={{ reason_for_declining: '' }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      validateOnBlur={true}
    >
      <Form>
        <div className="accept-or-decline-modal__body">
          <p>Please provide a reason for your decision</p>
          <div className="accept-or-decline-modal__field">
            <label htmlFor="reason_for_declining">Reason for declining</label>
            <Textarea
              id="reason_for_declining"
              name="reason_for_declining"
              label=""
              aria-label="Reason for declining"
              rows={4}
              className="accept-or-decline-modal__reason-textarea"
              errorPlacement="outside"
              errorClassName="accept-or-decline-modal__error"
            />
          </div>
        </div>
        <div className="accept-or-decline-modal__actions">
          <IonButton
            type="button"
            fill="outline"
            color="medium"
            aria-label="Cancel and close"
            onClick={onCancel}
          >
            Cancel
          </IonButton>
          <IonButton
            type="submit"
            color="tss-grey-dark"
            aria-label="Save reason and decline work order"
          >
            Save
          </IonButton>
        </div>
      </Form>
    </Formik>
  )
}

DeclineForm.propTypes = propTypes
DeclineForm.defaultProps = defaultProps

export default DeclineForm
